import React from 'react';
import { ColumnSelectOption } from 'lib/components/ColumnSelect';
import { Multiselect } from './Multiselect';

type OrganizationSelectorProps = {
  value: string[];
  options: ColumnSelectOption<string>[] | null;
  onChange: (value: string[]) => void;
};

export function OrganizationSelector({
  value,
  options,
  onChange
}: OrganizationSelectorProps) {
  return (
    <Multiselect
      value={value}
      onChange={onChange}
      options={options || []}
      placeholder="Select Newspapers"
      labelText="Select Newspapers"
    />
  );
}
